import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Assessment, AssessmentDto, AssessmentValue, AssessmentValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getAssessment(courseId: string): Observable<Assessment> {
        return this.httpClient.get<AssessmentDto>(`courses/${courseId}/assessment`).pipe(map((dto) => new Assessment(dto)));
    }

    createAssessment(courseId: string, value: AssessmentValue): Observable<Assessment> {
        const dto = new AssessmentValueDto(value);

        return this.httpClient.post<AssessmentDto>(`courses/${courseId}/assessment`, dto).pipe(map((response) => new Assessment(response)));
    }

    patchAssessment(id: string, value: AssessmentValue): Observable<Assessment> {
        const dto = new AssessmentValueDto(value);

        return this.httpClient.patch<AssessmentDto>(`assessments/${id}`, dto).pipe(map((response) => new Assessment(response)));
    }

    deleteAssessment(id: string): Observable<void> {
        return this.httpClient.delete<void>(`assessments/${id}`);
    }
}
